import React from 'react';

import ReferentCampaigns from '../../components/Communication/ReferentCampaigns/ReferentCampaigns.module';

function ReferentCampaignsView() {
  return (
    <ReferentCampaigns />
  );
}

export default ReferentCampaignsView;


